// Cover-crop to a centered square and resize to a JPEG. Keeps uploads small;
// the server independently validates size and sniffs the real type. Shared
// between the client-app and admin-panel avatar upload flows.
export async function resizeToSquareJpeg(file: File, size = 512): Promise<Blob> {
  // `imageOrientation: "from-image"` honors any EXIF orientation tag so mobile
  // photos don't bake in a rotation when flattened to JPEG.
  const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" })
  const side = Math.min(bitmap.width, bitmap.height)
  const sx = (bitmap.width - side) / 2
  const sy = (bitmap.height - side) / 2
  const canvas = document.createElement("canvas")
  canvas.width = canvas.height = size
  const ctx = canvas.getContext("2d")
  if (!ctx) throw new Error("Could not get canvas context")
  ctx.drawImage(bitmap, sx, sy, side, side, 0, 0, size, size)
  // toBlob reads from the canvas, not the bitmap, so free the decode now.
  bitmap.close()
  return new Promise<Blob>((resolve, reject) =>
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("Could not process image"))),
      "image/jpeg",
      0.85
    )
  )
}
